export const isMobile =
  'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0 && document.body.clientWidth < 600;
